
import React, { useEffect, useState } from 'react';
import { mergeStyleSets } from '@uifabric/merge-styles';
import { ComboBox } from 'office-ui-fabric-react/lib/ComboBox';

const classNames = mergeStyleSets({
    root: {

    }
});

const CategoryComboBox = (props) => {

    const [value, setValue] = useState(props.selectedCategory);

    useEffect(() => {
        if (props.onChangeCategory) {
            props.onChangeCategory(value);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [value]);

    const handleChangeItem = (event, option) => {
        setValue(option.key);
    }

    const getOptions = () => {
        let options = props.categories.map(item => {
            return {
                key: item.name,
                text: item.title
            };
        });

        if (!value) {
            if (options.length > 0) {
                setValue(options[0].key);
            }
        }

        return options;
    }

    return (
        <div className={classNames.root}>
            <ComboBox
                label="Kategorie parcel"
                options={getOptions()}
                selectedKey={value}
                onChange={handleChangeItem}
            />
        </div>
    );
}

export default CategoryComboBox;
